function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { InputFormatter, LinkedInputFormatter, TextFormatter } from '../Formatter';
const baseProps = {
  decimalScale: 3,
  suffix: '%',
  thousandSeparator: true
};

const Percent = props => React.createElement(TextFormatter, _extends({}, baseProps, props));

const PercentInput = props => React.createElement(InputFormatter, _extends({}, baseProps, props));

const LinkedPercentInput = props => React.createElement(LinkedInputFormatter, _extends({}, baseProps, props));

export { Percent, PercentInput, LinkedPercentInput };